//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'PageComponent',
    },
    contentType: {
      type: String,
      default: 'PageMentorsForm',
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
    theme: {
      type: String,
      default: 'emerald',
    },
    newLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        location: null,
        language: this.$i18n.locale,
      },
      isExpanded: false,
    }
  },
  computed: {
    /** TO-DO: in case of others forms, it's possible to create a function for each version pre-defined **/
    renderFormLocale() {
      return ['en_au', 'en_gb', 'de', 'pl', 'fr', 'nl'].includes(
        this.formData.language
      )
        ? this.formData.language
        : false
    },
    modifiedTitle() {
      return this.title
    },
  },
}
